<template>
<div class="main">
    <div>
        <DiamondQuizTitle @closePage="emitclosePage"/>
        <div class="message">
            <DiamondQuizDiamondMessage message="What's your estimated budget?"/>
        </div>    
        <div class="price_box text-center">
            <!-- <input :class="{'error' : isMinMaxError}" type="number" v-model="userInput"  @input="handleInput"> -->
            <!-- <input 
                type="range" 
                :class="{'error' : isMinMaxError}" 
                v-model="userInput"  
                :min="minmax.min" 
                :max="minmax.max" 
                @input="handleInput"
                step="1"
            > -->
            <!-- <div ref="slider" id="slider" class="budget-slider"></div> -->
            <div ref="slider" class="budget-slider"></div>
    
            <div class="errorMsg" v-if="isMinMaxError">
                <p v-if="userInput < minmax.min"> Minimum value should be greater than {{ $formatPrice(minmax.min) }}</p>
                <p v-if="userInput > minmax.max"> Maximum value should be less than {{ $formatPrice(minmax.max) }}</p>
            </div>
            <p class="price">Around  <span>{{ $formatPrice(userInput) }}</span></p>
        </div>
    </div>
    <div class="d-flex justify-content-center align-items-center flex-column">
        <button :class="{'disabled': isMinMaxError}" class="button text-center" @click="goToNextPage" :disabled="isMinMaxError">
            <span>proceed</span>
        </button>
        <DiamondQuizFooter/>
    </div>
</div>
</template>

<script setup>
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

// get min max for input

import { diamondQuizStore } from '@/stores/diamond_quiz/diamond_quiz';

const {$formatPrice} = useNuxtApp()

const store = diamondQuizStore()

const emit = defineEmits(['close'])
const userInput = ref(store.getBudget);

const slider = ref(null);

const isMinMaxError = ref(false)

const minmax = computed(()=>{
    return store.getMinMax
})



// const handleInput = (inputVal) => {
//     let value = inputVal.target.value

//     if(value < minmax.value.min || value > minmax.value.max){
//         isMinMaxError.value = true
//     }else{
//         isMinMaxError.value = false
//     }
// };

// const handleInput = () => {
//     // Check if the user input is within the range
//     isMinMaxError.value = userInput.value < minmax.value.min || userInput.value > minmax.value.max;
// };

const handleSliderUpdate = (value) => {
    userInput.value = +value[0];
    isMinMaxError.value = userInput.value < minmax.value.min || userInput.value > minmax.value.max;
};



const emitclosePage = () => {
    emit('close')
}


const goToNextPage = () => {
    if(!isMinMaxError.value){
        store.updateBudget(userInput.value);
        store.setNextPage()
    }
}

const initializeSlider = () => {
  noUiSlider.create(slider.value, {
    start: [userInput.value],
    connect: [true, false],
    range: {
      min: minmax.value.min,
      max: minmax.value.max
    },
    step: 10,
  });
  slider.value.noUiSlider.on('update', handleSliderUpdate);
};

watch(minmax, (newMinMax) => {
    if (slider.value && slider.value.noUiSlider) {
        slider.value.noUiSlider.updateOptions({
            range: {
                min: newMinMax.min,
                max: newMinMax.max
            }
        });
    }
});

onMounted(() => {
  initializeSlider();
});

</script>

<style scoped>

/* input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
 -webkit-appearance: none;
 margin: 0;
} */

/* input[type="range"] {
    width: 70%;
    height: 8px;
    border-radius: 4px;
    background: #c4c4c4;
    outline: none;
    appearance: none;
    -webkit-appearance: none;
}
input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    background: #f5f5f5;
    border: 1.6px solid #c4c4c4;
    box-shadow: 0 0 6.5px 0 rgba(0, 0, 0, 0.25);
    cursor: pointer;
    border-radius: 50%;
} */


.budget-slider {
    width: 70%;
    margin: 0 auto;
}

/* .noUi-tooltip {
    display: none !important;
}

.noUi-horizontal .noUi-tooltip {
    display: none !important;
} */

.content {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 3%;
}

.button {
    padding: 14px 30px;
    border: 1.5px solid var(--green);
    border-radius: 4px;
    width: 40%;
    margin: 0 auto;
    background: var(--green);
    cursor: pointer;
    margin-bottom: 3%;
}

.button span {
    font-size: 14px;
    letter-spacing: 1.4px;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
}
button.disabled{
    cursor: auto;
    opacity: 0.7;
}


.dialog_box {
    font-size: 18px;
    font-style: italic;
    color: #405955;
    border: 1px solid var(--green);
    border-radius: 4px;
    padding: 10px;
}

.form-label  {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 2px;
    color: #000000;
    text-transform: uppercase;
    margin-bottom: 20px;
}

.form-range {
    margin-bottom: 6%;
    border: none;
}

/* input {
    padding: 12px 16px;
    min-width: 160px;
} */

input:focus {
    outline: none;
}

input.error{
    border: 1px solid red;
}

.price_box {
    margin-bottom: 2%;
}


.price_box .price {
    font-size: 16px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: var(--green);
    margin-top: 20px;
}

.price_box span {
    color: #405955;
    font-weight: 600;
}

.main {
    display: flex;
    flex-direction: column;
}

.errorMsg {
    min-height: 30px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.errorMsg p{
    color: red;
    font-size: 14px;
    margin: 0;
    padding: 0;
    /* text-transform: capitalize; */
}

@media(max-width:992px){
    .content img {
        width: 100px;
        height: 100px;
    }
    .dialog_box {
        font-size: 16px;
    }

    .button {
        width: 60%;
        padding: 10px 15px;
    }

}

@media(max-width:768px) {
    .content img {
        width: 80px;
        height: 80px;
    }

    .dialog_box {
        font-size: 14px;
    }

    .button {
        width: 96%;
        /* padding: 14px 30px; */
    }
    .main {
        height: auto;
    }

    .budget-slider {
        width: 90%;
        margin: 0 auto;
    }
}

</style>